var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14.001,
    viewBox: "0 0 17 14.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clients",
    transform: "translate(-341.92 -540.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_34527",
    "data-name": "Path 34527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34534",
    "data-name": "Path 34534",
    d: "M354.056,554.019a.5.5,0,0,1-.5-.5v-1.456a2.412,2.412,0,0,0-2.409-2.409H345.33a2.412,2.412,0,0,0-2.41,2.409v1.456a.5.5,0,0,1-1,0v-1.456a3.414,3.414,0,0,1,3.41-3.409h5.817a3.413,3.413,0,0,1,3.409,3.409v1.456A.5.5,0,0,1,354.056,554.019Z",
    fill: "#474461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1305",
    "data-name": "Ellipse 1305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34535",
    "data-name": "Path 34535",
    d: "M348.42,547.019a3.5,3.5,0,1,1,3.5-3.5A3.505,3.505,0,0,1,348.42,547.019Zm0-6a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,348.42,541.019Z",
    fill: "#474461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_34528",
    "data-name": "Path 34528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34536",
    "data-name": "Path 34536",
    d: "M358.42,554.02a.5.5,0,0,1-.5-.5v-1.456a2.41,2.41,0,0,0-1.806-2.33.5.5,0,1,1,.25-.968,3.407,3.407,0,0,1,2.556,3.3v1.456A.5.5,0,0,1,358.42,554.02Z",
    fill: "#474461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_34529",
    "data-name": "Path 34529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34537",
    "data-name": "Path 34537",
    d: "M353.33,546.658a.5.5,0,0,1-.124-.984,2.409,2.409,0,0,0,0-4.667.5.5,0,1,1,.248-.969,3.409,3.409,0,0,1,0,6.6A.532.532,0,0,1,353.33,546.658Z",
    fill: "#474461"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.9a202bcd435973241510d238b52f130c.svg";
export { ForwardRef as ReactComponent };